import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./ServicesSection.module.css";

const services = [
  {
    number: "01",
    title: "Residential Design",
    description:
      "Transform your living spaces with premium residential interior design. From bespoke villas to modern apartments, we craft personalized homes that blend aesthetic elegance with functional living.",
    tags: ["Living Rooms", "Bedrooms", "Kitchens", "Bathrooms"],
    image: "/media/r1 copy.jpg",
  },
  {
    number: "02",
    title: "Commercial Design",
    description:
      "Elevate your corporate identity with state-of-the-art commercial interior design. We create highly functional workspaces, boutique offices, and modern commercial setups that impress clients.",
    tags: ["Offices", "Retail Spaces", "Hospitality"],
    image: "/commercial/PHOTO-2026-07-08-13-58-29.jpg",
  },
  {
    number: "03",
    title: "Renovations",
    description:
      "Breathe new life into your property with our comprehensive renovation services. We handle end-to-end structural updates, heritage restorations, and modern makeovers.",
    tags: ["Loft Conversions", "Heritage", "Full Makeovers"],
    image: "/media/l1 copy.jpg",
  },
  {
    number: "04",
    title: "Consultations",
    description:
      "Navigate your interior design journey with expert consultation. From spatial planning and colour theory to customized design guidance — we help you make informed decisions.",
    tags: ["Spatial Planning", "Colour Advice", "3D Walkthroughs"],
    image: "/media/h1 copy.jpg",
  },
];

const ServiceList = ({ className = "" }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section id="servicesection" className={[styles.serviceList, className].join(" ")}>
      <div className={styles.header}>
        <span className={styles.tag}>OUR SERVICES</span>
        <h2 className={styles.title}>A Brief Overview Of The Services We Offer</h2>
      </div>

      <div className={styles.serviceItems}>
        {services.map((svc, i) => (
          <div
            key={i}
            className={`${styles.serviceRow} ${activeIndex === i ? styles.active : ""}`}
            onMouseEnter={() => setActiveIndex(i)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <div className={styles.serviceLeft}>
              <span className={styles.serviceNumber}>{svc.number}</span>
              <h3 className={styles.serviceTitle}>{svc.title}</h3>
            </div>
            <div className={styles.serviceMiddle}>
              <p className={styles.serviceDesc}>{svc.description}</p>
              <div className={styles.tagRow}>
                {svc.tags.map((tag, j) => (
                  <span key={j} className={styles.serviceTag}>{tag}</span>
                ))}
              </div>
            </div>
            <div className={styles.serviceRight}>
              <div className={styles.imageReveal}>
                <img src={svc.image} alt={svc.title} />
              </div>
              <Link to="/contact" className={styles.arrow}>→</Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceList;
